/* eslint-disable no-undef */
import HttpService from './commons/HttpService';

const UserService = {
  getCurrentUser() {
    return HttpService.get('/user/me');
  },
  getMyCompany() {
    return HttpService.get('/user/myCompany');
  },
  getAccountStatus() {
    return HttpService.get('/user/accountStatus');
  },
  checkAccountStatus(isIOS) {
    return HttpService.get('/user/checkAccountStatus', { params: { isIOS } });
  },
  updateTheme(themeSettings) {
    return HttpService.put('/user/theme', themeSettings);
  },
  updateUserName(userBasicInfo) {
    return HttpService.put('/user/name', userBasicInfo);
  },
  updateUserEmail(userBasicInfo) {
    return HttpService.put('/user/email', userBasicInfo);
  },
  sendConfirmationCode() {
    return HttpService.post('/user/email/code');
  },
  getUserInfo() {
    return HttpService.get('/user/info');
  },
  checkInstalledAppVersion(lastInstalledAppVersionString, currentUserId, currentInstalledVersion) {
    return HttpService.get('/user/registerBuildNumber', {
      params: {
        lastInstalledAppVersionString,
        currentUserId,
        currentInstalledVersion,
      },
    });
  },
  registerInstalledAppVersion(buildNumber, deviceId) {
    return HttpService.post('/user/registerBuildNumber', { buildNumber, deviceId });
  },
  signUp(user) {
    return HttpService.post('/signUp', user);
  },
  becomeFree() {
    return HttpService.post('/user/becomeFree');
  },
  becomePaid() {
    return HttpService.post('/user/becomePaid');
  },
};

export default UserService;
